import Credentials from "./Credentials.jsx";
export default Credentials